import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5f8a215f"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "一", -1));
import BaseRule from '../BaseRule.vue';
import { computed } from 'vue';
export default {
  __name: 'Age',
  props: ['index', 'item', 'data'],
  setup(__props) {
    const props = __props;
    const index = computed(() => props.index);
    const item = computed(() => props.item);
    const data = computed(() => props.data);
    const word = {
      name: 'Age'
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createBlock(BaseRule, {
        word: word,
        index: _unref(index),
        data: _unref(data)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _unref(item).minValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(item).minValue = $event),
          modelModifiers: {
            number: true
          },
          class: "input"
        }, null, 8, ["modelValue"]), _hoisted_1, _createVNode(_component_el_input, {
          modelValue: _unref(item).maxValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(item).maxValue = $event),
          modelModifiers: {
            number: true
          },
          class: "input"
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["index", "data"]);
    };
  }
};